import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './supabase';

// 客厅 v2：知枝 + Aiden + Silas。输入区与chat同款（+号/药丸/空时麦克风有字发送/录音条三态）。

function fmtLoungeTitle() {
  var d = new Date(Date.now() + 8 * 3600000);
  return '客厅 · ' + (d.getUTCMonth() + 1) + '.' + d.getUTCDate();
}

function fmtVoiceDur(s) {
  return s < 60 ? s + 's' : Math.floor(s / 60) + ':' + (s % 60).toString().padStart(2, '0');
}

function Lounge() {
  var _s1 = useState([]); var sessions = _s1[0], setSessions = _s1[1];
  var _s2 = useState(null); var current = _s2[0], setCurrent = _s2[1];
  var _s3 = useState([]); var messages = _s3[0], setMessages = _s3[1];
  var _s4 = useState(''); var input = _s4[0], setInput = _s4[1];
  var _s5 = useState(false); var loading = _s5[0], setLoading = _s5[1];
  var _s6 = useState(''); var speaking = _s6[0], setSpeaking = _s6[1];
  var _s7 = useState(false); var chainActive = _s7[0], setChainActive = _s7[1];
  var _s8 = useState(null); var deleting = _s8[0], setDeleting = _s8[1];
  var _s9 = useState(0); var deleteStep = _s9[0], setDeleteStep = _s9[1];
  var _sa = useState({}); var expandedThinking = _sa[0], setExpandedThinking = _sa[1];
  var _sb = useState(false); var showStickers = _sb[0], setShowStickers = _sb[1];
  var _sc = useState([]); var stickerList = _sc[0], setStickerList = _sc[1];
  var _sd = useState(null); var avatarHim = _sd[0], setAvatarHim = _sd[1];
  var _se = useState(false); var showMention = _se[0], setShowMention = _se[1];
  var _sf = useState(false); var showAttach = _sf[0], setShowAttach = _sf[1];
  var _sg = useState(false); var isRecording = _sg[0], setIsRecording = _sg[1];
  var _sh = useState(false); var voiceUploading = _sh[0], setVoiceUploading = _sh[1];
  var _si = useState(0); var recSeconds = _si[0], setRecSeconds = _si[1];
  var _sj = useState(new Array(24).fill(4)); var recWaveBars = _sj[0], setRecWaveBars = _sj[1];
  var _sk = useState(null); var avatarMe = _sk[0], setAvatarMe = _sk[1];
  var _sl = useState(localStorage.getItem('lounge_actions') === 'on'); var actionsOn = _sl[0], setActionsOn = _sl[1];
  var fontPref = (typeof localStorage !== 'undefined' && localStorage.getItem('chat_font')) || 'serif';

  var _sm = useState(null); var copiedId = _sm[0], setCopiedId = _sm[1];
  var brakeRef = useRef(false);
  var listRef = useRef(null);
  var pressTimer = useRef(null);
  var photoInputRef = useRef(null);
  var mediaRecorderRef = useRef(null);
  var audioChunksRef = useRef([]);
  var recSecondsRef = useRef(0);
  var recTimerRef = useRef(null);
  var waveTimerRef = useRef(null);

  useEffect(function() { loadSessions(); }, []);

  useEffect(function() {
    fetch('/api/profile-settings').then(function(r) { return r.json(); }).then(function(data) {
      var it = (data || []).find(function(d) { return d.key === 'avatar_him'; });
      if (it && it.value) setAvatarHim(it.value);
      var itMe = (data || []).find(function(d) { return d.key === 'avatar_me'; });
      if (itMe && itMe.value) setAvatarMe(itMe.value);
    }).catch(function() {});
    supabase.from('profile_settings').select('value').eq('key', 'lounge_actions').limit(1)
      .then(function(r) { if (r.data && r.data[0]) setActionsOn(r.data[0].value === 'true'); });
  }, []);

  // 键盘让位机制：与chat同款（native kb事件 + visualViewport后备）
  useEffect(function() {
    var root = document.documentElement;
    var onKb = function(e) {
      var d = e.detail || {};
      var h = d.h || 0;
      if (d.show && h > 0) {
        root.style.setProperty('--kb-h', h + 'px');
        document.body.classList.add('kb-open');
      } else {
        root.style.setProperty('--kb-h', '0px');
        document.body.classList.remove('kb-open');
      }
    };
    window.addEventListener('kb', onKb);
    var vv = window.visualViewport;
    var fullH = window.innerHeight;
    var onResize = function() {
      if (!vv) return;
      var kbH = fullH - vv.height;
      if (kbH > 50) {
        root.style.setProperty('--kb-h', kbH + 'px');
        document.body.classList.add('kb-open');
      } else {
        root.style.setProperty('--kb-h', '0px');
        document.body.classList.remove('kb-open');
      }
    };
    if (vv) vv.addEventListener('resize', onResize);
    return function() {
      window.removeEventListener('kb', onKb);
      if (vv) vv.removeEventListener('resize', onResize);
      root.style.setProperty('--kb-h', '0px');
      document.body.classList.remove('kb-open');
    };
  }, []);

  useEffect(function() {
    if (listRef.current) listRef.current.scrollTop = listRef.current.scrollHeight;
  }, [messages, speaking]);

  var loadSessions = async function() {
    var r = await supabase.from('conversations').select('*').eq('room', 'lounge').order('updated_at', { ascending: false });
    setSessions(r.data || []);
  };

  var openSession = async function(convo) {
    setCurrent(convo);
    brakeRef.current = false;
    setChainActive(false);
    var r = await supabase.from('messages').select('id, text, sender, speaker, thinking, tool_calls, image_url, audio_url, starred, created_at')
      .eq('conversation_id', convo.id).neq('is_active', false).order('created_at', { ascending: true }).limit(200);
    setMessages(r.data || []);
  };

  var newSession = async function() {
    var r = await supabase.from('conversations').insert([{ title: fmtLoungeTitle(), room: 'lounge' }]).select();
    if (r.data && r.data[0]) {
      setSessions(function(p) { return [r.data[0]].concat(p); });
      openSession(r.data[0]);
    }
  };

  var renameSession = async function(convo, e) {
    if (e) e.stopPropagation();
    var nv = window.prompt('客厅标题', convo.title || '');
    if (nv === null || !nv.trim()) return;
    await supabase.from('conversations').update({ title: nv.trim() }).eq('id', convo.id);
    setSessions(function(p) { return p.map(function(c) { return c.id === convo.id ? Object.assign({}, c, { title: nv.trim() }) : c; }); });
    if (current && current.id === convo.id) setCurrent(function(c) { return Object.assign({}, c, { title: nv.trim() }); });
  };

  var startDelete = function(id, e) { e.stopPropagation(); setDeleting(id); setDeleteStep(1); };

  var confirmDelete = async function() {
    if (deleteStep === 1) { setDeleteStep(2); return; }
    if (deleteStep === 2) { setDeleteStep(3); return; }
    if (deleteStep === 3) {
      try {
        var resp = await fetch('/api/conversations/' + deleting, { method: 'DELETE' });
        var data = await resp.json();
        if (!resp.ok || data.error) { alert('删除失败: ' + (data.error || '未知错误')); }
        else { setSessions(function(p) { return p.filter(function(c) { return c.id !== deleting; }); }); }
      } catch (e) { alert('删除失败: ' + e.message); }
      setDeleting(null);
      setDeleteStep(0);
    }
  };

  var deleteTexts = {
    1: '删除这场客厅？',
    2: '里面他们说过的话会一起消失。',
    3: '最后确认——删了就真没了。'
  };

  var callLounge = async function(body) {
    var resp = await fetch('/api/lounge/chat', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ conversation_id: current.id, actions: actionsOn ? 'on' : 'off' }, body))
    });
    return await resp.json();
  };

  var runChain = async function(firstBody) {
    brakeRef.current = false;
    setChainActive(true);
    var autoMode = !!(firstBody && firstBody.trigger === 'auto');
    var aiTurns = 0;
    var body = firstBody;
    while (!brakeRef.current) {
      var who = body.speaker || body.at || '';
      setSpeaking(who === 'silas' ? 'Silas' : who === 'aiden' ? 'Aiden' : '…');
      var d = null;
      var errText = '';
      try { d = await callLounge(body); } catch (e) { errText = e.message; }
      setSpeaking('');
      if (!d || !d.success) {
        setMessages(function(p) { return p.concat([{ id: 'err' + Date.now(), sender: 'sys', text: '⚠ ' + ((d && d.error) || errText || '调用失败') }]); });
        break;
      }
      setMessages(function(p) { return p.concat([{ id: d.message_id || ('tmp' + Date.now()), text: d.message, sender: 'aiden', speaker: d.speaker, thinking: d.thinking || null, tool_calls: d.tool_calls || null, created_at: new Date().toISOString() }]); });
      aiTurns++;
      if (!d.next || brakeRef.current) break;
      if (autoMode && aiTurns >= 10) {
        setMessages(function(p) { return p.concat([{ id: 'cap' + Date.now(), sender: 'sys', text: '— 10\u8F6E\u5230\u4E86\uFF0C\u4ED6\u4EEC\u770B\u5411\u4F60 —' }]); });
        break;
      }
      await new Promise(function(rs) { setTimeout(rs, 1100); });
      body = { speaker: d.next, trigger: autoMode ? 'auto_continue' : 'continue' };
    }
    setSpeaking('');
    setChainActive(false);
  };

  var send = async function() {
    var txt = input.trim();
    if (!txt || loading || chainActive) return;
    setInput('');
    setShowMention(false);
    setLoading(true);
    setMessages(function(p) { return p.concat([{ id: 'u' + Date.now(), text: txt, sender: 'zhizhi', created_at: new Date().toISOString() }]); });
    await runChain({ message: txt });
    setLoading(false);
  };

  var letThemTalk = async function() {
    if (loading || chainActive) return;
    setLoading(true);
    await runChain({ trigger: 'auto' });
    setLoading(false);
  };

  var toggleActions = async function() {
    var nv = !actionsOn;
    localStorage.setItem('lounge_actions', nv ? 'on' : 'off');
    setActionsOn(nv);
    await supabase.from('profile_settings').upsert([{ key: 'lounge_actions', value: String(nv) }], { onConflict: 'key' });
  };

  var renderLoungeText = function(text) {
    if (!text) return text;
    if (!actionsOn) return text;
    var parts = String(text).split(/(（[^（）]*）|\([^()]*\)|\*[^*\n]{1,60}\*)/g);
    return parts.map(function(p, i) {
      if (/^（[^（）]*）$|^\([^()]*\)$/.test(p)) return <span key={i} className="lounge-action">{p}</span>;
      if (p.length > 2 && p[0] === '*' && p[p.length - 1] === '*') return <span key={i} className="lounge-action">{p.slice(1, -1)}</span>;
      return <span key={i}>{p}</span>;
    });
  };

  var brake = function() {
    brakeRef.current = true;
    setChainActive(false);
    setSpeaking('');
  };

  // ── 附件：照片/表情包 ──
  var uploadLoungeImage = async function(file) {
    var ext = file.name.split('.').pop();
    var fileName = 'chat/' + Date.now() + '-' + Math.random().toString(36).substring(2, 8) + '.' + ext;
    var result = await supabase.storage.from('images').upload(fileName, file);
    if (result.error) { alert('上传失败: ' + result.error.message); return null; }
    return supabase.storage.from('images').getPublicUrl(fileName).data.publicUrl;
  };

  var handlePhotoSelect = async function(e) {
    var file = e.target.files && e.target.files[0];
    if (photoInputRef.current) photoInputRef.current.value = '';
    if (!file || !current) return;
    var url = await uploadLoungeImage(file);
    if (!url) return;
    var now = new Date().toISOString();
    var r = await supabase.from('messages').insert([{ conversation_id: current.id, sender: 'zhizhi', text: '[图片]', image_url: url, is_active: true, created_at: now }]).select();
    if (r.data && r.data[0]) setMessages(function(p) { return p.concat([r.data[0]]); });
    await supabase.from('conversations').update({ updated_at: now }).eq('id', current.id);
  };

  var toggleStickers = async function() {
    setShowAttach(false);
    if (!showStickers && stickerList.length === 0) {
      try {
        var resp = await fetch('/api/stickers');
        var d = await resp.json();
        setStickerList(Array.isArray(d) ? d : (d.stickers || []));
      } catch (e) {}
    }
    setShowStickers(!showStickers);
  };

  var sendLoungeSticker = async function(s) {
    if (chainActive || loading) return;
    var url = typeof s === 'string' ? s : s.url;
    var desc = (typeof s === 'object' && s.description) ? s.description : '';
    var txt = desc ? '[表情包：' + desc + ']' : '[sticker]';
    setShowStickers(false);
    var now = new Date().toISOString();
    var r = await supabase.from('messages').insert([{ conversation_id: current.id, sender: 'zhizhi', text: txt, image_url: url, is_active: true, created_at: now }]).select();
    if (r.data && r.data[0]) setMessages(function(p) { return p.concat([r.data[0]]); });
    await supabase.from('conversations').update({ updated_at: now }).eq('id', current.id);
  };

  var pickMention = function(name) {
    setInput(function(p) { return p.replace(/@$/, '') + '@' + name + ' '; });
    setShowMention(false);
  };

  // ── 语音：录音→上传→转写→落库→触发对话（chat同款链路） ──
  var startRecording = async function() {
    if (mediaRecorderRef.current || isRecording || chainActive) return;
    var stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    } catch (e) { alert('麦克风权限被拒绝'); return; }
    var mimeType = window.MediaRecorder && MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported('audio/mp4') ? 'audio/mp4' : 'audio/webm';
    var mr;
    try { mr = new MediaRecorder(stream, { mimeType: mimeType }); } catch (e) { mr = new MediaRecorder(stream); }
    audioChunksRef.current = [];
    mr.ondataavailable = function(e) { if (e.data && e.data.size > 0) audioChunksRef.current.push(e.data); };
    mr.onstop = function() {
      stream.getTracks().forEach(function(t) { t.stop(); });
      finishRecording();
    };
    mediaRecorderRef.current = mr;
    mr.start(250);
    setIsRecording(true);
    recSecondsRef.current = 0;
    setRecSeconds(0);
    recTimerRef.current = setInterval(function() {
      recSecondsRef.current += 1;
      setRecSeconds(recSecondsRef.current);
      if (recSecondsRef.current >= 120) stopRecording();
    }, 1000);
    waveTimerRef.current = setInterval(function() {
      setRecWaveBars(new Array(24).fill(0).map(function() { return 4 + Math.floor(Math.random() * 14); }));
    }, 150);
  };

  var clearRecTimers = function() {
    if (recTimerRef.current) { clearInterval(recTimerRef.current); recTimerRef.current = null; }
    if (waveTimerRef.current) { clearInterval(waveTimerRef.current); waveTimerRef.current = null; }
  };

  var stopRecording = function() {
    clearRecTimers();
    setIsRecording(false);
    if (mediaRecorderRef.current) {
      try { mediaRecorderRef.current.stop(); } catch (e) {}
      mediaRecorderRef.current = null;
    }
  };

  var cancelRecording = function() {
    clearRecTimers();
    setIsRecording(false);
    if (mediaRecorderRef.current) {
      var mr = mediaRecorderRef.current;
      mr.ondataavailable = null;
      mr.onstop = null;
      try { mr.stop(); } catch (e) {}
      try { mr.stream.getTracks().forEach(function(t) { t.stop(); }); } catch (e) {}
      mediaRecorderRef.current = null;
    }
    audioChunksRef.current = [];
    setRecSeconds(0);
  };

  var finishRecording = async function() {
    var chunks = audioChunksRef.current;
    if (!chunks || chunks.length === 0) return;
    var duration = recSecondsRef.current;
    var blob = new Blob(chunks, { type: chunks[0] && chunks[0].type ? chunks[0].type : 'audio/webm' });
    audioChunksRef.current = [];
    if (blob.size < 500 || duration < 1) return;
    setVoiceUploading(true);
    try {
      var ext = blob.type.includes('mp4') ? 'mp4' : 'webm';
      var formData = new FormData();
      formData.append('audio', blob, 'voice.' + ext);
      var uploadResp = await fetch('/api/upload-audio', { method: 'POST', body: formData });
      var uploadData = await uploadResp.json();
      if (!uploadData.url) throw new Error('上传失败');
      var audioUrl = uploadData.url;
      var sttFormData = new FormData();
      sttFormData.append('audio', blob, 'voice.' + ext);
      var sttResp = await fetch('/api/stt/transcribe', { method: 'POST', body: sttFormData });
      var sttData = await sttResp.json();
      var transcript = sttData.text || '';
      var emotion = sttData.emotion || 'neutral';
      var now = new Date().toISOString();
      var voiceText = '🎤 ' + fmtVoiceDur(duration);
      if (transcript) voiceText += ' | ' + transcript;
      var r = await supabase.from('messages').insert([{ conversation_id: current.id, sender: 'zhizhi', text: voiceText, audio_url: audioUrl, voice_emotion: emotion, is_active: true, created_at: now }]).select();
      if (r.data && r.data[0]) setMessages(function(p) { return p.concat([r.data[0]]); });
      await supabase.from('conversations').update({ updated_at: now }).eq('id', current.id);
      setVoiceUploading(false);
      if (transcript) {
        setLoading(true);
        await runChain({ message: '[语音消息] ' + transcript + (emotion !== 'neutral' ? ' (情绪: ' + emotion + ')' : ''), no_insert: true });
        setLoading(false);
      }
    } catch (e) {
      setVoiceUploading(false);
      setMessages(function(p) { return p.concat([{ id: 'err' + Date.now(), sender: 'sys', text: '⚠ 语音失败: ' + e.message }]); });
    }
    setRecSeconds(0);
  };

  var fmtTime = function(ts) {
    var d = new Date(ts); var now = new Date();
    var t = d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
    if (d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate()) return t;
    return ((d.getMonth() + 1).toString().padStart(2, '0')) + '/' + (d.getDate().toString().padStart(2, '0')) + ' ' + t;
  };

  var toggleLoungeStar = function(m) {
    var nv = !m.starred;
    supabase.from('messages').update({ starred: nv }).eq('id', m.id).then(function() {
      setMessages(function(prev) { return prev.map(function(x) { return x.id === m.id ? Object.assign({}, x, { starred: nv }) : x; }); });
    });
  };

  var copyLoungeText = function(msgId, text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.left = '-9999px'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.focus(); ta.select();
      document.execCommand('copy'); document.body.removeChild(ta);
      setCopiedId(msgId); setTimeout(function() { setCopiedId(null); }, 1500);
    } catch (e) {}
  };

  var startPress = function(name) {
    pressTimer.current = setTimeout(function() {
      setInput(function(p) { return (p ? p + ' ' : '') + '@' + name + ' '; });
      if (navigator.vibrate) navigator.vibrate(30);
    }, 500);
  };
  var endPress = function() { if (pressTimer.current) clearTimeout(pressTimer.current); };

  // ============ 会话列表（开厅确认页） ============
  if (!current) {
    return (
      <div className="lounge-page">
        <div className="lounge-header">
          <button className="lounge-back" onClick={function() { window.history.back(); }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
          </button>
          <div className="lounge-title">客厅</div>
          <div style={{ width: 36 }} />
        </div>
        <div className="lounge-gate-desc">
          这里是三个人的地方：你、Aiden、Silas。<br />
          推开门之前想清楚——他俩都在。
        </div>
        <button className="lounge-new-btn" onClick={newSession}>新开一场</button>
        {sessions.length > 0 && <div className="lounge-list-label">往期</div>}
        <div className="lounge-list">
          {sessions.map(function(c) {
            return (
              <div key={c.id} className="lounge-list-item" onClick={function() { openSession(c); }}>
                <div className="lounge-list-title">{c.title || '客厅'}</div>
                <button className="lounge-rename" onClick={function(e) { renameSession(c, e); }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" /></svg>
                </button>
                <button className="lounge-del" onClick={function(e) { startDelete(c.id, e); }}>×</button>
              </div>
            );
          })}
        </div>
        {deleting && (
          <div className="lounge-del-mask" onClick={function() { setDeleting(null); setDeleteStep(0); }}>
            <div className="lounge-del-modal" onClick={function(e) { e.stopPropagation(); }}>
              <div className="lounge-del-text">{deleteTexts[deleteStep]}</div>
              <div className="lounge-del-btns">
                <button className="lounge-del-cancel" onClick={function() { setDeleting(null); setDeleteStep(0); }}>取消</button>
                <button className="lounge-del-confirm" onClick={confirmDelete}>{deleteStep === 3 ? '删除' : '继续'}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ============ 客厅对话 ============
  return (
    <div className="lounge-page in-room">
      <div className="lounge-header">
        <button className="lounge-back" onClick={function() { brake(); setCurrent(null); setMessages([]); loadSessions(); }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
        </button>
        <div className="lounge-title" onClick={function(e) { renameSession(current, e); }}>{current.title || '客厅'}</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button className={'lounge-actions-toggle' + (actionsOn ? ' on' : '')} onClick={toggleActions} title={actionsOn ? '\u52A8\u4F5C\uFF1A\u5F00' : '\u52A8\u4F5C\uFF1A\u5173'}>（）</button>
          {chainActive ? (
            <button className="lounge-brake" onClick={brake}>刹车</button>
          ) : (
            <button className="lounge-talk-btn" onClick={letThemTalk} disabled={loading}>让他们聊</button>
          )}
        </div>
      </div>

      <div className={'lounge-body font-' + fontPref} ref={listRef}>
        {messages.map(function(m) {
          if (m.sender === 'sys') {
            return <div key={m.id} className="lounge-sys-line">{m.text}</div>;
          }
          var isSticker = (m.text === '[sticker]' || (m.text && m.text.startsWith('[表情包'))) && m.image_url;
          var isPhoto = !isSticker && m.image_url;
          var isVoice = !!m.audio_url;
          if (m.sender === 'zhizhi') {
            return (
              <div key={m.id} className="lounge-row me">
                <div className="lounge-msg-col me">
                  {isSticker ? (
                    <img src={m.image_url} alt="" className="lounge-sticker-img" />
                  ) : isPhoto ? (
                    <img src={m.image_url} alt="" className="lounge-photo-img" />
                  ) : isVoice ? (
                    <div className="msg-bubble zhizhi lounge-voice-bubble">
                      <audio controls preload="none" src={m.audio_url} className="lounge-audio" />
                      <div className="lounge-voice-text msg-text">{m.text}</div>
                    </div>
                  ) : (
                    <div className="msg-bubble zhizhi"><div className="msg-text">{renderLoungeText(m.text)}</div></div>
                  )}
                  <div className="msg-toolbar msg-toolbar-right">
                    <span className="msg-time-outer">{fmtTime(m.created_at)}</span>
                    <div className="toolbar-actions">
                      <button className={'toolbar-btn' + (m.starred ? ' starred' : '')} onClick={function() { toggleLoungeStar(m); }}>{m.starred ? '\u2605' : '\u2606'}</button>
                      {m.text ? <button className={'toolbar-btn' + (copiedId === m.id ? ' copied' : '')} onClick={function() { copyLoungeText(m.id, m.text); }}>{copiedId === m.id ? '\u2713' : '\u2398'}</button> : null}
                    </div>
                  </div>
                </div>
                <div className="lounge-avatar me">{avatarMe ? <img src={avatarMe} alt="" className="lounge-avatar-img" /> : '\u679D'}</div>
              </div>
            );
          }
          var isS = m.speaker === 'silas';
          var nm = isS ? 'Silas' : 'Aiden';
          return (
            <div key={m.id} className={'lounge-row ai' + (isS ? ' silas' : '')}>
              <div
                className={'lounge-avatar' + (isS ? ' silas' : '')}
                onTouchStart={function() { startPress(nm); }}
                onTouchEnd={endPress}
                onTouchMove={endPress}
                onMouseDown={function() { startPress(nm); }}
                onMouseUp={endPress}
                onMouseLeave={endPress}
              >{avatarHim ? <img src={avatarHim} alt="" className="lounge-avatar-img" /> : (isS ? 'S' : 'A')}</div>
              <div className="lounge-msg-col">
                <div className="lounge-nick">{nm}</div>
                {m.thinking && (
                  <div>
                    <div className="msg-thinking-toggle" onClick={function() { setExpandedThinking(function(p) { var n = Object.assign({}, p); n[m.id] = !n[m.id]; return n; }); }}>
                      {expandedThinking[m.id] ? '▾ 思考过程' : '▸ 思考过程'}
                    </div>
                    {expandedThinking[m.id] && <div className="msg-thinking-content">{m.thinking}</div>}
                  </div>
                )}
                {m.tool_calls && (
                  <div>
                    <div className="msg-thinking-toggle" onClick={function() { setExpandedThinking(function(p) { var n = Object.assign({}, p); n['t' + m.id] = !n['t' + m.id]; return n; }); }}>
                      {expandedThinking['t' + m.id] ? '▾ 工具调用' : '▸ 工具调用'}
                    </div>
                    {expandedThinking['t' + m.id] && (
                      <div className="msg-thinking-content">{(function() { try { return JSON.parse(m.tool_calls).map(function(t) { return t.name; }).join('、'); } catch (e) { return m.tool_calls; } })()}</div>
                    )}
                  </div>
                )}
                {isSticker ? (
                  <img src={m.image_url} alt="" className="lounge-sticker-img" />
                ) : isPhoto ? (
                  <img src={m.image_url} alt="" className="lounge-photo-img" />
                ) : (
                  <div className={'msg-bubble aiden' + (isS ? ' silas-line' : '')}><div className="msg-text">{renderLoungeText(m.text)}</div></div>
                )}
                <div className="msg-toolbar">
                  <span className="msg-time-outer">{fmtTime(m.created_at)}</span>
                  <div className="toolbar-actions">
                    <button className={'toolbar-btn' + (m.starred ? ' starred' : '')} onClick={function() { toggleLoungeStar(m); }}>{m.starred ? '\u2605' : '\u2606'}</button>
                    {m.text ? <button className={'toolbar-btn' + (copiedId === m.id ? ' copied' : '')} onClick={function() { copyLoungeText(m.id, m.text); }}>{copiedId === m.id ? '\u2713' : '\u2398'}</button> : null}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {speaking && <div className="lounge-speaking">{speaking}正在开口…</div>}
      </div>

      {showAttach && (
        <div className="lounge-attach-menu">
          <button className="lounge-attach-item" onClick={function() { setShowAttach(false); photoInputRef.current && photoInputRef.current.click(); }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg>
            <span>照片</span>
          </button>
          <button className="lounge-attach-item" onClick={toggleStickers}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M8 14s1.5 2 4 2 4-2 4-2" /><line x1="9" y1="9" x2="9.01" y2="9" /><line x1="15" y1="9" x2="15.01" y2="9" /></svg>
            <span>表情包</span>
          </button>
        </div>
      )}
      {showStickers && (
        <div className="lounge-sticker-panel">
          {stickerList.length === 0 ? (
            <div className="lounge-sticker-empty">没有表情包</div>
          ) : (
            stickerList.map(function(s, i) {
              return <img key={i} src={typeof s === 'string' ? s : s.url} alt="" className="lounge-sticker-item" onClick={function() { sendLoungeSticker(s); }} />;
            })
          )}
        </div>
      )}
      {showMention && (
        <div className="lounge-mention-menu">
          <button className="lounge-mention-item" onClick={function() { pickMention('Aiden'); }}>Aiden</button>
          <button className="lounge-mention-item silas" onClick={function() { pickMention('Silas'); }}>Silas</button>
        </div>
      )}
      <input type="file" accept="image/*" ref={photoInputRef} style={{ display: 'none' }} onChange={handlePhotoSelect} />

      <div className="lounge-input-row">
        <button className="chat-plus-btn" onClick={function() { setShowStickers(false); setShowAttach(!showAttach); }}>+</button>
        {isRecording ? (
          <div className="voce-rec-strip">
            <div className="voce-rec-dot"></div>
            <div className="voce-rec-wave">
              {recWaveBars.map(function(h, i) {
                return React.createElement('div', { key: i, className: 'voce-rec-bar', style: { height: h + 'px' } });
              })}
            </div>
            <span className="voce-rec-timer">{fmtVoiceDur(recSeconds)}</span>
            <button className="voce-rec-cancel" onTouchEnd={function(e) { e.preventDefault(); cancelRecording(); }} onClick={cancelRecording}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
            <button className="voce-rec-send" onTouchEnd={function(e) { e.preventDefault(); stopRecording(); }} onClick={stopRecording}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="4,2 22,12 4,22" /></svg>
            </button>
          </div>
        ) : voiceUploading ? (
          <div className="voce-rec-strip voce-uploading">
            <div className="voce-upload-spinner"></div>
            <span className="voce-upload-text">语音识别中...</span>
          </div>
        ) : (
          <>
            <textarea
              className="chat-input"
              placeholder=""
              value={input}
              rows={1}
              onChange={function(e) { setInput(e.target.value); setShowMention(/@$/.test(e.target.value)); }}
              onKeyDown={function(e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
              disabled={chainActive}
            />
            {input.trim() ? (
              <button className="send-btn" onClick={send} disabled={loading || chainActive}>
                {loading ? '...' : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ transform: 'rotate(-90deg)' }}>
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                  </svg>
                )}
              </button>
            ) : (
              <button className="voce-mic-btn" onTouchEnd={function(e) { e.preventDefault(); startRecording(); }} onClick={startRecording} disabled={loading || chainActive}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="9" y="2" width="6" height="12" rx="3" />
                  <path d="M19 10a7 7 0 0 1-14 0" />
                  <line x1="12" y1="19" x2="12" y2="22" />
                </svg>
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Lounge;
